import ServiceSection from './ServiceSection'

export default ServiceSection
